import type {
    Translatable} from "@@/shared/translations/translation";
import {
    isTranslatable
} from "@@/shared/translations/translation";
import type { PageBlock } from "../page-block";

const isPageBlockWithTitle = <T extends PageBlock>(
    pageBlock: T,
): pageBlock is T & { title: Translatable } => {
    const title = ("title" in pageBlock && pageBlock.title) || undefined;
    return typeof title === "string"
        ? !!title.trim()
        : isTranslatable(title) && !!title.sv?.trim();
};

export { isPageBlockWithTitle };
